module.exports = __webpack_public_path__ + "img/music.ef03eeae.svg";